import { ModelCommon } from './ModelCommon'
import { IsLocatableByPosition } from './Interfaces/ModelInterfaces'
import { GeofencePointsType, isGeofencePointsType } from '../types/ModelTypes'

const typeName = 'GatewayData'

class GatewayData extends ModelCommon implements IsLocatableByPosition {
  constructor(ob: any) {
    super(typeName, ob)
  }
  getLatLon(): GeofencePointsType | undefined {
    let res = undefined
    const { latitude: lat, longitude: lng } = this
    if (isGeofencePointsType({ lat, lng })) res = { lat, lng }
    else {
      console.log(`could not get posiition on Gateway ${this.name}, with `, { lat, lng })
    }
    return res
  }
}

export { GatewayData }
